import { lazy } from 'react'
const TrasladoCursos = lazy(() => import('./TrasladoCursos'))
const BusquedaAlumCursos = lazy(() => import('./BusquedaAlumCursos'))
const Paso2  =  lazy(() => import('./Paso2'))
const Paso3  =  lazy(() => import('./Paso3'))
const Paso1  =  lazy(() => import('./Paso1'))
const Cursos =  lazy(() => import( './Cursos'))

export {
    Paso1,
    Paso2,
    Paso3,
    Cursos,
    BusquedaAlumCursos,
    TrasladoCursos,
}